import { remoteConfigConstants } from './remote.config.constants';

export const remoteConfigEndpoints = {
    GET_REMOTE_CONFIG: {
        url: process.env.REACT_APP_SERVER_URL + remoteConfigConstants.REMOTE_CONFIG_ROUTES.REMOTE_CONFIG,
    },
    UPDATE_REMOTE_CONFIG: {
        url: process.env.REACT_APP_SERVER_URL + remoteConfigConstants.REMOTE_CONFIG_ROUTES.REMOTE_CONFIG,
    },
};
